import React from "react";

export function PageHeader({ eyebrow, title, description, actions }) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 pb-5 md:pb-6 border-b border-zinc-200 mb-6 md:mb-8">
      <div className="min-w-0">
        {eyebrow && <div className="label-eyebrow mb-2" data-testid="page-eyebrow">{eyebrow}</div>}
        <h1
          className="font-display text-3xl sm:text-4xl md:text-5xl font-black tracking-tighter leading-none break-words"
          data-testid="page-title"
        >
          {title}
        </h1>
        {description && <p className="mt-3 text-sm text-zinc-600 max-w-xl">{description}</p>}
      </div>
      {actions && (
        <div className="flex items-center gap-2 flex-wrap md:justify-end shrink-0">
          {actions}
        </div>
      )}
    </div>
  );
}

export function PageContainer({ children }) {
  return <div className="p-4 sm:p-6 md:p-10 max-w-[1600px]">{children}</div>;
}

export function StatCard({ label, value, hint, testid }) {
  return (
    <div className="bg-white border border-zinc-200 p-4 sm:p-6" data-testid={testid}>
      <div className="label-eyebrow">{label}</div>
      <div className="font-display text-3xl sm:text-4xl font-black tracking-tighter mt-2">{value}</div>
      {hint && <div className="text-xs text-zinc-500 mt-2">{hint}</div>}
    </div>
  );
}

export function EmptyState({ title, description, action }) {
  return (
    <div className="border border-dashed border-zinc-300 bg-white p-8 sm:p-12 text-center" data-testid="empty-state">
      <div className="font-display text-xl sm:text-2xl font-bold tracking-tight">{title}</div>
      {description && <div className="text-sm text-zinc-500 mt-2 max-w-md mx-auto">{description}</div>}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}

/**
 * Wraps a table in a horizontally scrollable container so it never breaks the mobile layout.
 * Usage: <TableWrap><table className="w-full text-sm">…</table></TableWrap>
 */
export function TableWrap({ children, minWidth = 720, className = "" }) {
  return (
    <div className={`bg-white border border-zinc-200 overflow-x-auto ${className}`}>
      <div style={{ minWidth }}>{children}</div>
    </div>
  );
}
